/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./TransDetailReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
// fExecuteAPI
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebTransDetailReportData,
  sWebBetweenReportArr,
  GetWMSMISAttributes,
  GetWmsStockRepotParty,
  fValidationHead_Client,
  fValidationDetail_Client,
  GetSearchItem,
  GetItemFullSearchArr,
} from "./TransDetailReportAction";

import * as React from "react";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";

export default function TransDetailReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const sBufferObjInit = {
    sDetailReportRadioBtnName: "UNCOMPLETED",
  };

  const [sBufferObj, setBufferObj] = useState(sBufferObjInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  const [sTransactionData, setTransactionData] = useState([]);

  const [sDocTypeData, setDocTypeData] = useState([]);

  const [sPartyData, setPartyData] = useState([]);
  const [sClusterData, setClusterData] = useState([]);

  //Detail
  const DetailReportRadioBtn = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailReportRadioBtnName: e.target.value,
    }));
  };

  //Item start
  const GridDataColumnsItemSearch = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ];

  const ItemSearchData = ["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"];
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const fItem = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItem: e.target.value,
      sItemName: "",
      sItemCode: "",
    }));
  };
  const fItemName = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItemName: e.target.value,
    }));
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(HeadObject.sItemName);

      if (vItemSearchFull.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sItemCode: vItemSearchFull[0].ItmCd,
          sItemName: vItemSearchFull[0].Name2,
        }));
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: "",
        sItemName: e.target.value,
      }));
    }
  };

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd);
    if (vItemSearchFull.length > 0) {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: vItemSearchFull[0].ItmCd,
        sItemName: vItemSearchFull[0].Name2,
      }));
      // document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      // document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: HeadObject.sItemName,
    }));

    if (HeadObject.sItemName != "") {
      GetSearchItem(HeadObject.sItemName, "Any", setGridSelectRowData);
    }

    handleClick();
  };
  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
          // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  //Item End

  //Head

  const fDocType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocType: e.target.value,
      sDocTypeArr: [],
      sDocTypePrnt: "",
      sDocTypeName: "",
    }));
  };
  const fDocType_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sDocTypeArr: value,
      sDocTypePrnt: value?.length <= 0 ? "" : currentPrnt,
      sDocTypeName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };
  const fDocNo_Input = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocNo_Input: e.target.value,
    }));
  };

  const fDocNo = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocNo: e.target.value,
      sDocNo_Input: "",
    }));
  };

  const fTransaction = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sTransaction: e.target.value,
      sTransactionArr: [],
      sTransactionPrnt: "",
      sTransactionName: "",
    }));
  };
  const fTransaction_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sTransactionArr: value,
      sTransactionPrnt: value?.length <= 0 ? "" : currentPrnt,
      sTransactionName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
    if (value?.length <= 0) {
      fLocation_Focus();
    }
  };
  const fLocation_Focus = (value) => {};

  //common_PartyListReport_GETROW
  const fParty = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sPartyArr: [],
      sPartyPrnt: "",
      sPartyName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setPartyData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotParty(setPartyData);
    }
  };
  const fParty_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sPartyArr: value,
      sPartyPrnt: value?.length <= 0 ? "" : currentPrnt,
      sPartyName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_ClusterListReport_GETROW
  const fCluster = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sClusterArr: [],
      sClusterPrnt: "",
      sClusterName: "",
    }));
  };
  const fCluster_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sClusterArr: value,
      sClusterPrnt: value?.length <= 0 ? "" : currentPrnt,
      sClusterName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
    setBufferObj(sBufferObjInit);
    // setPartyData([]);
    // setClusterData([]);
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";

    let ReportTitleObj = {
      DateBetween:
        "Between " +
        moment(HeadObject.sFromDate).format("DD-MM-YYYY") +
        " and " +
        moment(HeadObject.sToDate).format("DD-MM-YYYY"),
      party: HeadObject.sPartyName,
      Document: HeadObject.sDocTypeName,
      Transaction: HeadObject.sTransactionName,
      Cluster: HeadObject.sClusterName,
      DocNo: HeadObject.sDocNo_Input,
      ItemName: HeadObject.sItemName,
      Location: HeadObject.sLocationName,
    };

    // Remove the trailing "&" character
    sReportTitle = ReportTitle(ReportTitleObj);

    let ReportUrlObj = {
      ReportType: sBufferObj.sDetailReportRadioBtnName,
      Date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      Date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      Party: HeadObject.sPartyPrnt,
      VocTyp: HeadObject.sDocTypePrnt,
      Trans: HeadObject.sTransactionPrnt,
      Cluster: HeadObject.sClusterPrnt,
      DocNo: HeadObject.sDocNo_Input,
      ItmCd: HeadObject.sItemCode,
      Loc: HeadObject.sLocationPrnt,
      reportTitle: sReportTitle,
    };

    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    // console.log("ReportUrlObj", ReportUrlObj);
    // console.log("sCurrentReport", sCurrentReport);
    console.log(
      "sCurrentReportTransDetail",
      urlPrint +
        "(S(u30rjf5ihmqrpzgohu02rmeq))/WMS/TransDetail?" +
        sCurrentReport
    );
    setWebReportUrlModal(
      urlPrint +
        "/(S(u30rjf5ihmqrpzgohu02rmeq))/WMS/TransDetail?" +
        sCurrentReport
    );
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;
    let iValidationDetail_Client = fValidationDetail_Client(
      sBufferObj,
      HeadObject
    );
    if (!iValidationDetail_Client) return;
    await GetReportsView();
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetWMSMISAttributes(
      setTransactionData,
      setPartyData,
      setClusterData,
      setDocTypeData,
      setLocationData
    );
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDocNo_Input={fDocNo_Input}
                fDocNo={fDocNo}
                fDate={fDate}
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                fParty_MultiSelect={fParty_MultiSelect}
                sPartyData={sPartyData}
                fCluster_MultiSelect={fCluster_MultiSelect}
                sClusterData={sClusterData}
                fTransaction_MultiSelect={fTransaction_MultiSelect}
                fDocType_MultiSelect={fDocType_MultiSelect}
                sWebTransDetailReportData={sWebTransDetailReportData}
                sWebBetweenReportArr={sWebBetweenReportArr}
                sTransactionData={sTransactionData}
                sDocTypeData={sDocTypeData}
                HeadObject={HeadObject}
                fLocation={fLocation}
                fParty={fParty}
                fCluster={fCluster}
                fTransaction={fTransaction}
                fDocType={fDocType}
                //items
                fItem={fItem}
                fItemName_onKeyUp={fItemSearchKey}
                fItemName={fItemName} //onchange main input
                xMediaQuery={vMediaQuery} //mobile screen
                xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                xData={ItemSearchData} // GCToggleSearch-select-tag arr
                xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={vMediaQuery ? "hide-content" : " "}
            >
              <WmsContent
                DetailReportRadioBtn={DetailReportRadioBtn}
                xtitle={"Detail Report"}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={"auto"}
              className={
                vMediaQuery ? "text-center" : "text-center hide-content"
              }
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail Report"} onClose={fCloseSummaryModal} />

          <div className="py-3 px-2">
            <WmsContent
              DetailReportRadioBtn={DetailReportRadioBtn}
              xtitle={"Detail Report"}
              selectedOption={sBufferObj.sDetailReportRadioBtnName}
            />
          </div>
        </Box>
      </Modal>

      {/* webReport  */}

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
